import { render, staticRenderFns } from "./InventoryBestPractices.vue?vue&type=template&id=5b4c1c22&scoped=true&"
import script from "./InventoryBestPractices.vue?vue&type=script&lang=js&"
export * from "./InventoryBestPractices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c1c22",
  null
  
)

export default component.exports